import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// SPA routes don't reset scroll position automatically like full page
// navigations do. This restores that behaviour on every route change,
// and additionally scrolls to an in-page anchor (e.g. "/#products")
// once the target route has rendered.
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // wait a tick for the destination page to render before measuring
      const id = hash.replace("#", "");
      const raf = requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
      return () => cancelAnimationFrame(raf);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
